module.exports = __webpack_public_path__ + "img/smartCity1.f9df7fa9.png";